import { Button, Input, InputType, View, ViewHeader } from '../../../../core/components/Index';
import { observer } from 'mobx-react';
import { useNavigate } from 'react-router-dom';
import OraViewModel from './OraViewModel';
import { Appl } from '../../../../core/Appl';
import { AppPermissions } from '../../../../core/services/AppPermissions';

const OraView = observer(() => {
  const vm = Appl.Services.get<OraViewModel>('OraViewModel');
  vm.navigate = useNavigate();

  return (
    <>
      <View
        id="OraView"
        pageTitle='Online Retirement Application'
        showMenuBar={false} authKey={AppPermissions.PublicAccess}      >
        <ViewHeader title='Online Retirement Application' backUrl="" />
        <p>Please note down the Identifier if you need to continue to work on the application draft..</p>
        <div className="space-y-[36px] mt-[24px]" id="formContainer">
          <div className="grid md:grid-cols-3 gap-4">
            <div>
              <Input
                id="guId"
                value={vm.model.guId}
                onChange={(e) => vm.onInputChange(e, 'guId', vm.model)}
                label="Member Identifier"
                required={true}
                maxLength={40}
              />
            </div>
            {/* <div>
              <Input
                id="firstName"
                value={vm.model.firstName}
                onChange={(e) => vm.onInputChange(e, 'firstName', vm.model)}
                label="First Name"
                required={true}
                maxLength={40}
              />
            </div>
            <div>
              <Input
                id="middleInitial"
                value={vm.model.middleInitial}
                onChange={(e) => vm.onInputChange(e, 'middleInitial', vm.model)}
                label="Middle Initial"
                required={false}
                maxLength={10}
              />
            </div>
            <div>
              <Input
                id="lastName"
                value={vm.model.lastName}
                onChange={(e) => vm.onInputChange(e, 'lastName', vm.model)}
                label="Last Name"
                required={true}
                maxLength={40}
              />
            </div>
            <div>
              <Input
                id="email"
                value={vm.model.email}
                inputType={InputType.Email}
                onChange={(e) => vm.onInputChange(e, 'email', vm.model)}
                label="Email Address"
                required={true}
                maxLength={40}
              />
            </div> */}
          </div>
          <div className="grid md:grid-cols-3 gap-4">
            <Button onClick={async () => await vm.getFormattedUrlAsync()} title='Apply for Retirement' />
          </div>
        </div>
      </View >
    </>
  );
});

export default OraView;
